import {Outlet} from 'react-router-dom'

const TeamStack = () => (<Outlet/>)

export default TeamStack
